import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import TrackingListComponent from "components/ActionTracking/List";
import { mapStateToProps } from "store/helpers/mapState";
import { mapDispatchToProps } from "store/helpers/mapDispatch";
import { Badge, Box, Button, Card, Tab, Tabs } from "@mui/material";
import { a11yProps } from "components/Meetings/Meeting";
import { TabPanel } from "components/Meetings/Meeting";
import MyAssignmentListComponent from "components/ActionTracking/MyAssignedList";
import { Link } from "react-router-dom";
import { Add } from "@mui/icons-material";
import AddModal from "../../components/ActionTracking/AddModal";
import { errorToast, successToast } from "../../helpers/Notification";
import {
  getError,
  getSuccessMessage,
} from "../../store/helpers/common_functions";

const ActionTrackingManagement = (props) => {
  const {
    selectedFolder,
    GetAllMeetings,
    meetings,
    location,
    loggedUser,
    GetAllInvitedIn,
    invitedIn,
    settings,
    MarkAsRead,
    GetEmployees,
    resources,
    SetSelectedMenu,
    GetAllResources,
    SubmitGeneralForm,
    systemSettings,
  } = props;
  const mainBackground = systemSettings?.mainBackground;

  const [notificationList, setNotificationsList] = useState([]);
  const [select, setSelect] = useState(false);
  const [loading, setLoading] = useState(false);
  const [listOfAction, setListOfAction] = useState([]);

  const [type, setType] = useState("");
  const [info, setInfo] = useState({});
  const [refresh, setRefresh] = useState(0);
  const [value, setValue] = useState(location?.state?.tab ?? 0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => GetAllMeetings("All"), [GetAllMeetings]);
  useEffect(() => GetAllInvitedIn("All"), [GetAllInvitedIn]);

  useEffect(() => {
    SetSelectedMenu({
      menu: "action",
      title: "Action Tracking",
    });
    GetAllResources();
  }, []);

  const onSubmit = async (info) => {
    setLoading(true);
    const response = await SubmitGeneralForm(
      "api/meeting-action/",
      [info],
      null
    );
    setLoading(false);
    if (response?.status) {
      successToast(getSuccessMessage(response));
      setRefresh((old) => old + 1);
      return false;
    } else {
      errorToast(getError(response));
      return true;
    }
  };

  return (
    <div className="w-full mb-12 px-4">
      <div className="">
        <div className="flex justify-between items-center">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item pageTitle">
                <Link
                  to="/admin/action"
                  className="text-white text-decoration-none"
                >
                  Action Tracking
                </Link>
              </li>
            </ol>
          </nav>
          {select && (
            <AddModal
              setType={setType}
              setInfo={setInfo}
              resources={resources?.data}
              GetEmployees={GetEmployees}
              info={info}
              type={type}
              settings={settings}
              loggedUser={loggedUser}
              needDirectSubmit={true}
              onSubmit={onSubmit}
              setListOfAction={setListOfAction}
              listOfAction={listOfAction}
              setSelect={setSelect}
              select={select}
              loading={loading}
              systemSettings={systemSettings}
            />
          )}
          <div className="row justify-content-end">
            <div className="col-md-5 flex justify-end ">
              <div className={"flex-grow-1 me-2"}></div>
              <div className={"me-2"}>
                <Button
                  style={{
                    backgroundColor: mainBackground,
                    color: "white",
                  }}
                  variant={"contained"}
                  onClick={() => {
                    setSelect(true);
                  }}
                  size={"small"}
                  startIcon={<Add />}
                >
                  ADD NEW
                </Button>
              </div>
            </div>
          </div>
        </div>
        <Card className={"overflow-auto mt-3"} variant={"outlined"}>
          <div className={"card-body mt-0 pt-0"}>
            <div className="row group-btn">
              <div className="col-md-7"></div>
            </div>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label="My Task" {...a11yProps(0)} iconPosition={"end"} />
                <Tab
                  label={
                    <span>
                      Assigned <Badge className={"mb-3"} color="error" />
                    </span>
                  }
                  iconPosition={"end"}
                  {...a11yProps(1)}
                />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <TrackingListComponent
                selectedFolder={selectedFolder}
                meetings={meetings}
                GetAllMeetings={GetAllMeetings}
                GetAllInvitedIn={GetAllInvitedIn}
                location={location}
                refresh={refresh}
                loggedUser={loggedUser}
                invitedIn={invitedIn}
                settings={settings}
                notification={notificationList}
                MarkAsRead={MarkAsRead}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <MyAssignmentListComponent
                selectedFolder={selectedFolder}
                meetings={meetings}
                GetAllMeetings={GetAllMeetings}
                GetAllInvitedIn={GetAllInvitedIn}
                location={location}
                loggedUser={loggedUser}
                invitedIn={invitedIn}
                settings={settings}
                notification={notificationList}
                MarkAsRead={MarkAsRead}
              />
            </TabPanel>
          </div>
        </Card>
      </div>
    </div>
  );
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActionTrackingManagement);
